import { ApolloError, useMutation } from '@apollo/client';
import { PRODUCT_LIST_PATH } from 'constants/path';
import { GraphQLError } from 'graphql';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { errorHandler } from 'utils/ErrorHandler';
import HackleManager from 'utils/hackle';
import { REQUEST_INSPECTION } from '..';

export function useMutationRequestInspection() {
  const navigate = useNavigate();
  const [requestInspection, { loading: isRequestInspectionLoading }] =
    useMutation(REQUEST_INSPECTION);

  const [isOpenModal, setisOpenModal] = useState<{
    success: boolean;
    failed: boolean;
  }>({ success: false, failed: false });
  const [errorMessage, setErrorMessage] = useState<string[]>([]);

  const handleRequestInspection = async (
    productId: string,
    callback?: () => void,
  ) => {
    if (isRequestInspectionLoading) {
      return;
    }

    try {
      const response = await requestInspection({ variables: { productId } });

      if (response) {
        setisOpenModal({ success: true, failed: false });
        // navigate(PRODUCT_LIST_PATH);

        HackleManager.logCreateStepFourReviewRequestCompleteView(
          Number(productId),
        );

        callback && callback();
      }
    } catch (error) {
      setisOpenModal({ success: false, failed: true });

      if (error instanceof ApolloError) {
        const graphQLError = error.graphQLErrors?.[0];
        if (graphQLError) {
          const exceptionErrors = (graphQLError.extensions?.exception as any)
            ?.errors;

          if (Array.isArray(exceptionErrors)) {
            setErrorMessage(exceptionErrors.map(item => item.message));
          } else {
            setErrorMessage([graphQLError.message]);
          }
        } else if (error.networkError) {
          setErrorMessage(['네트워크 오류가 발생했습니다. 다시 시도해주세요.']);
        } else {
          setErrorMessage([error.message]);
        }
      } else {
        setErrorMessage(['알 수 없는 오류가 발생했습니다. 다시 시도해주세요.']);
      }
    }
  };

  return {
    isOpenModal,
    errorMessage,
    isRequestInspectionLoading,
    handleRequestInspection,
  };
}
